/* eslint-disable camelcase */
export default {
	home: '首页',
	my_dashboard: '我的工作台',
	project_planning: 'Project Planning',
	project_planning_desc_1: 'Project planning includes applying for master projects and campaigns.',
	procurement_and_acceptance: 'Procurement and Acceptance',
	procurement_and_acceptance_desc_1:
		'A successful procurement needs to identify the need for marketing services, research potential vendors, issue requests for proposals, evaluate proposals, select a vendor, negotiate a contract, and ultimately acquire the services.',
	procurement_and_acceptance_desc_2:
		'Acceptance of service orders is needed after the order is completed. This involves testing, validating the services, and collecting KPI ratio data to ensure they are fit for purpose and meet the agreed-upon quality standards.',
	project_closing_and_evaluation: 'Project Closing and Evaluation',
	project_closing_and_evaluation_desc_1:
		"When a project is finished, use pre-set KPI ratios to accurately measure a project's outcome. Collecting and analyzing project data and establishing an overseas marketing data warehouse for future project analysis. ",
	new_campaign: 'New Campaign',
	new_campaign_desc_1: 'Create new campaign under master project. An MBA campaign will be automatically created at the same time.',
	purchase_request_and_supplier_selection: 'Purchase Request and Supplier Selection',
	purchase_request_and_supplier_selection_desc_1:
		'Business team submit purchase request in GMS. Procurement team analyze requests and select the most suitable supplier.',
	contract_order: 'Contract / Order',
	contract_order_desc_1: 'Sign contract and placing orders accordingly.',
	service_acceptance: 'Service Acceptance',
	service_acceptance_desc_1:
		'After the order is finished, business team check service deliverables, fill out KPI ratios and conduct service acceptance.',
	payment: 'Payment',
	payment_desc_1: 'Create payments to suppliers after service acceptance.',
	project_closing_evaluation: 'Project Closing & Evaluation',
	project_closing_evaluation_desc_1: 'Collecting and analyzing project KPI ratios.',
	what_to_do_next: 'What to do next?',
	initiate_this_project_based_on_project_initiation_and_suppliers: 'Initiate this project based on project initiation and suppliers',
	create_a_new_project: 'Create a new project',
	need_any_help: 'Need any help?',
	useful_toolkit: 'Useful Toolkit',
	quotation_template: 'Quotation Template',
	same_order_query: 'Same Order Query',
	framework_agreement_query: 'Framework Agreement Query',
	contact: 'Contact',
	contract_person_name: 'IEG：Audreywang(wangkeke)；',
	guidance: 'Guidance',
	bfc_usage_guidelines: 'BFC Usage Guidelines',
	task_summary:
		'您当前有<strong>{taskNum}</strong>相关事项，其中待办<strong>{todoNum}</strong>项、已完成<strong>{completedNum}</strong>项、相关项目<strong>{projectNum}</strong>项',
	my_pending_tasks: '我的待办',
	my_completed_tasks: '我的已办',
	projects_i_m_monitoring: '我关注的项目',
	project_creation: 'Project Creation',
	project_creation_desc_1: 'Creating a new project',
	requirements: 'Requirements',
	requirements_desc_1: 'Requirements are necessary features for a product, service, or system to meet stakeholder expectations.',
	supplier_evaluation: 'Supplier Evaluation',
	supplier_evaluation_desc_1:
		'Supplier evaluation is the process of measuring and assessing the performance and capabilities of potential or current suppliers.',
	contract_my_dashboard: 'Contract',
	contract_desc_1:
		'A contract is a legally binding agreement between two or more parties that outlines the terms and conditions of their relationship.',
	purchasing_order: 'Purchasing Order',
	purchasing_order_desc_1:
		'A purchase order is a commercial document issued by a buyer to a seller, indicating the type, quantity, and agreed prices for products or services.',
	service_goods_receiving: 'Service/Goods Receiving',
	service_goods_receiving_desc_1:
		'A purchase order is a commercial document issued by a buyer to a seller, indicating the type, quantity, and agreed prices for products or services.',
	payment_my_dashboard: 'Payment',
	payment_my_dashboard_desc_1: 'Payment is the transfer of money, goods, or services in exchange for something else.',
	project_closure: 'Project Closure',
	project_closure_desc_1:
		'Project closure is the final phase of a project, where the project team completes all remaining activities to formally close out the project.',
	real_time_update_at: '以上信息为即时数据，更新于{time}.',
	no_decision_required: '无需决策',
	no_order_generated: '未生成订单',
	no_order_created: '未创建订单',
	payment_status: '付款情况',
	closing_status: '结项情况',
	requirement_resource_type: '需求资源类型',
	requirement_ticket_amount: '需求单金额',
	ordered_amount: '已下单金额',
	remaining_orderable_amount: '可下单剩余金额',
	// accepted_amount: '已验收金额 - {currency}',
	// order_number: '订单编号',
	order_name: '订单名称',
	current_order_acceptance_status: '当前订单验收状态',
	acceptance_status: '验收情况',
	planning_stage: '计划阶段',
	execution_stage: '执行阶段',
	evaluation_stage: '评估阶段',
	campaign_name: '项目名称',
	purchase_require: 'Purchase Require',
	related_decision_number: 'Related decision number',
	current_handler: '当前处理人',
	supplier_name: '供应商名称',
	total: '合计',
	order_amount: '订单金额',
	acceptance_amount: '验收金额',
	agreed_payment_amount: '约定付款金额',
	payment_summary: 'Payment Summary',
	project_completion_summary: 'Project Completion Summary',
	used_amount: 'Used Amount',
	available_amount: 'Available Amount',
	project_amount: 'Project Amount',
	approval_status: 'Approval Status',
	created_time: 'Created Time',
	create_purchase_order: 'Create Purchase Order',
	project_completion: 'Project completion',
	create_decision: 'Create Decision',
	create_order: 'Create Order',
	create_acceptance: 'Create Acceptance',
	create_payment: 'Create Payment',
	no_data_available: '暂无数据',

	// 供应商新增的------------------------------

	enterprise_info: '供应商信息',
	supplier_nature: '供应商性质',
	certificate_license_number: '证书/证照号码',
	supplier_management_system: '供应商管理系统',
	bid_opening_evaluation_admission: '开标 · 评估 · 准入',
	tencent_supplier_portal: '腾讯供应商门户',
	invitation_number: '邀请单号',
	invitation_type: '邀请类型',
	bg: 'BG',
	supplier_category: '供应商类别',
	response_time: '响应时间',
	enquiry_number: '需求单号',
	enquiry_name: '需求名称',
	invitation_acceptance_deadline: '接受邀请截止时间',
	// proposal_and_quotation_deadline: 'Proposal And quotation Deadline',
	response_status: '响应状态',
	operate: '操作',
	order_number: '订单编号',
	contract_number: '合同编号',
	buyer: '买方',
	order_date: '订单日期',
	purchaser: '采购员',
	currency: '币种',
	sum: '总计',
	accepted_amount: '已验收金额',
	order_type: '订单类型',
	expected_acceptance_date: '预计验收日期',
	invitations_not_processed: '未处理注册邀请',
	enquiries_not_processed: '未处理需求',
	order_and_acceptance_pending: '订单及验收待审批',
	customer_search: '自定义搜索',
	register_by_supplier: '自主注册',
	filter: '过滤',
	exit: '退出',
	to_do_list: '待办',
	completed: '已办',
	register_info: '注册信息',
	first: 'First',
	second: 'Second',
	third: 'Third',
	data_types: '单据类型',
	no: '单号',
	invitations_processed: '已处理注册邀请',
	enquiries_processed: '已处理需求',
	order_processed: '订单已办',
	acceptance_processed: '验收已办',
	proposal_and_quotation_submission: '提交提案和报价',
	proposal_and_quotation_deadline: '方案报价截止时间',
	order_status: '订单状态',
	acceptance_completion_date: '验收完成时间',
	expected_payment_date: '预计付款时间',
	payment_info: '付款信息',
	acceptance_certificate_number: '验收单号',
	status: '状态',
	system: '系统',
	announcement: '公告',
	more: '更多',
	initiate_acceptance: '创建验收',
	detail: '详情',
	system_announcement: '系统公告',
	name: '邀请经办人',
	telephone: '经办人联系电话',
	address: '经办人联系地址',
	vendor_category: '邀请品类',
	invitation_date: '邀请时间',
	static: '静态',
	dynamic: '动态',
	please_enter_the_tracking_number: '请输入搜索的单号！',
	please_enter_buyer_or_purchaser: '请输入买方或者采购员！',
	po_pending_acceptance: '待验收PO',
	error_home_page_tip_1: '未找到绑定的供应商。',
	error_home_page_tip_2: '请查看是否选择了合适的角色，或者联系87000财经线IT热线。',
	bind_supplier: '绑定供应商',
	payment_no: '付款单号',
	currency_name: '支付币种',
	amount: '付款金额',
	fin_status_name: '状态',
	new_user_application: '新用户申请',
	administrator_application: '管理员申请'
};
